import { defineMessages } from 'react-intl'

const scope = 'app.containers.NFTTablePage'

export default defineMessages({
  header: {
    id: `${scope}.header`,
    defaultMessage: 'Crypto',
  },
  count: {
    id: `${scope}.count`,
    defaultMessage: 'Crypto: {displayed} of {total}',
  },
  filters: {
    id: `${scope}.filters`,
    defaultMessage: 'Filters',
  },
})
